'use client'

import { useAtom } from 'jotai'
import Script from 'next/script'
import { globalData } from '@/store'
import { APP_FLAG, DOU_YIN_FLAG, WO_HEADER_FOOTER, PREVIEW_FLAG, DISPLAY_FLAG } from '@/constants/global'
import { StorageKey } from '@/constants/storage'
import useStoreUTMActivityIdAndCid from '@/hooks/use-store-activity-cid'
import { useEffect } from 'react'
import { getBodyStyle } from '@/services'
import { VehicleBodyStyle } from '@/types/global'
import config from '@/config'

const GlobalLogic = () => {
  const [, setGlobalData] = useAtom(globalData)

  useStoreUTMActivityIdAndCid()

  const requestBodyStyles = (preview: boolean) => {
    getBodyStyle(preview).then(
      (res: {
        data: {
          bodyStyles: VehicleBodyStyle[]
        }
      }) => {
        const bodyStyles = res?.data?.bodyStyles
        setGlobalData((prev: any) => ({
          ...prev,
          bodyStyles,
        }))
      }
    )
  }

  useEffect(() => {
    if ( typeof window !== 'undefined' && window.location.search.includes(PREVIEW_FLAG)) {
      sessionStorage.setItem(StorageKey.IS_PREVIEW, 'true')
    }
    if (
      typeof window !== 'undefined' &&
      (window.location.pathname.includes(WO_HEADER_FOOTER))
    ) {
      sessionStorage.setItem(StorageKey.WO_HEADER_FOOTER, 'true')
      requestBodyStyles(sessionStorage.getItem(StorageKey.IS_PREVIEW) === 'true')
    }
    if (typeof window !== 'undefined' && window.location.search.includes(APP_FLAG)) {
      sessionStorage.setItem(StorageKey.IS_FROM_SALES_APP, 'true')
      sessionStorage.setItem(StorageKey.SOURCE_NAME, 'salesapp')
      if (window.location.search.includes(DISPLAY_FLAG)) {
        sessionStorage.setItem(StorageKey.IS_DISPLAY_CTA, 'true')
      }
    }
    if (typeof window !== 'undefined' && window.location.search.includes(DOU_YIN_FLAG)) {
      sessionStorage.setItem(StorageKey.IS_FROM_DOU_YIN_MNP, 'true')
      sessionStorage.setItem(StorageKey.SOURCE_NAME, 'douyinmnp')
    }

  }, [])
  return <>
    <Script src={config.APP_JS_SDK} />
  </>
}

export default GlobalLogic
